import { callApi } from '@local_modules/generic/fetch.js'

export async function syncManagementListeners (clickEvent, accountingOrganisationId) {
  console.log('syncManagementListeners', clickEvent)
  const buttonElement = clickEvent.target.closest('.button')
  if (!buttonElement) return

  buttonElement.classList.add('is-loading')

  const targetAction = buttonElement.getAttribute('data-action')
  console.log('buttonElement', buttonElement, targetAction, accountingOrganisationId)

  await actions[targetAction](accountingOrganisationId)

  buttonElement.classList.remove('is-loading')
  buttonElement.setAttribute('disabled', 'disabled')
}

const actions = {
  scheduleSyncPostgres: async function (accountingOrganisationId) {
    await callApi('/api/sync-pg/schedule/:accountingOrganisationId', {
      accountingOrganisationId
    }, { method: 'POST' })
  },
  generateLedger: async function (accountingOrganisationId) {
    await callApi('/api/sync-pg/generate-ledger/:accountingOrganisationId', {
      accountingOrganisationId
    }, { method: 'POST' })
  },

  deletePgData: async function (accountingOrganisationId) {
    await callApi('/api/data-review/delete-pg-data/:accountingOrganisationId/all', {
      accountingOrganisationId
    }, { method: 'DELETE' })
  },
  deletePgDataJournals: async function (accountingOrganisationId) {
    await callApi('/api/data-review/delete-pg-data/:accountingOrganisationId/journals', {
      accountingOrganisationId
    }, { method: 'DELETE' })
  },
  deletePgDataLedger: async function (accountingOrganisationId) {
    await callApi('/api/data-review/delete-pg-data/:accountingOrganisationId/ledger', {
      accountingOrganisationId
    }, { method: 'DELETE' })
  },
  deletePgDataSources: async function (accountingOrganisationId) {
    await callApi('/api/data-review/delete-pg-data/:accountingOrganisationId/sources', {
      accountingOrganisationId
    }, { method: 'DELETE' })
  },
  deletePgDataTrialBalances: async function (accountingOrganisationId) {
    await callApi('/api/data-review/delete-pg-data/:accountingOrganisationId/trialbalances', {
      accountingOrganisationId
    }, { method: 'DELETE' })
  }

}
